<div class="auth-container">
  <div class="auth-card">
    <div class="auth-header">
      <div class="logo-container">
        <img src="assets/logo/bee.png" alt="BizzWeaver" class="auth-logo" />
      </div>
      <h1 class="auth-title">{{ 'RESET_PASSWORD_TITLE' | translate }}</h1>
      <p class="auth-subtitle">{{ 'RESET_PASSWORD_SUBTITLE' | translate }}</p>
    </div>

    @if (errorMessage) {
      <div class="error-banner">
        <ion-icon name="close-circle"></ion-icon>
        <span>{{ errorMessage | translate }}</span>
      </div>
    }

    @if (isSubmitted) {
      <div class="success-state">
        <div class="success-icon">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
        </div>
        <h2 class="success-title">{{ 'RESET_PASSWORD_SUCCESS_TITLE' | translate }}</h2>
        <p class="success-message">{{ 'RESET_PASSWORD_SUCCESS_MESSAGE' | translate }}</p>
        <button class="submit-button" (click)="goToLogin()">
          {{ 'BACK_TO_LOGIN' | translate }}
        </button>
      </div>
    }

    @if (!isSubmitted) {
      <form (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label for="password" class="form-label">{{ 'NEW_PASSWORD' | translate }}</label>
          <div class="input-wrapper" [class.invalid]="password.length > 0 && !allRequirementsMet">
            <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              [(ngModel)]="password"
              name="password"
              class="form-input"
              [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
              autocomplete="new-password"
              (input)="onPasswordChange()"
              required
              />
              <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                <ion-icon [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
              </button>
            </div>
          </div>
          @if (password.length > 0) {
            <div class="password-requirements">
              <div class="requirement" [class.met]="passwordRequirements.minLength">
                <ion-icon [name]="passwordRequirements.minLength ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                <span>{{ 'PASSWORD_MIN_LENGTH' | translate }}</span>
              </div>
              <div class="requirement" [class.met]="passwordRequirements.hasUppercase">
                <ion-icon [name]="passwordRequirements.hasUppercase ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                <span>{{ 'PASSWORD_UPPERCASE' | translate }}</span>
              </div>
              <div class="requirement" [class.met]="passwordRequirements.hasLowercase">
                <ion-icon [name]="passwordRequirements.hasLowercase ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                <span>{{ 'PASSWORD_LOWERCASE' | translate }}</span>
              </div>
              <div class="requirement" [class.met]="passwordRequirements.hasNumber">
                <ion-icon [name]="passwordRequirements.hasNumber ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                <span>{{ 'PASSWORD_NUMBER' | translate }}</span>
              </div>
              <div class="requirement" [class.met]="passwordRequirements.hasSpecialChar">
                <ion-icon [name]="passwordRequirements.hasSpecialChar ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                <span>{{ 'PASSWORD_SPECIAL' | translate }}</span>
              </div>
            </div>
          }
          <div class="form-group">
            <label for="confirmPassword" class="form-label">{{ 'CONFIRM_PASSWORD' | translate }}</label>
            <div class="input-wrapper" [class.invalid]="!passwordsMatch() && confirmPassword.length > 0">
              <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                [(ngModel)]="confirmPassword"
                name="confirmPassword"
                class="form-input"
                [placeholder]="'CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                autocomplete="new-password"
                required
                />
                <button type="button" class="password-toggle" (click)="toggleConfirmPasswordVisibility()">
                  <ion-icon [name]="showConfirmPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                </button>
              </div>
              @if (!passwordsMatch() && confirmPassword.length > 0) {
                <span class="error-text">
                  {{ 'PASSWORDS_NOT_MATCH' | translate }}
                </span>
              }
            </div>
            <button type="submit" class="submit-button" [disabled]="isLoading || !isFormValid()">
              @if (isLoading) {
                <ion-spinner name="crescent"></ion-spinner>
              }
              @if (!isLoading) {
                <span>{{ 'RESET_PASSWORD_BUTTON' | translate }}</span>
              }
            </button>
          </form>
        }
      </div>
    </div>
